import React from 'react';
const items = [{
  name: '5 Tomi Didattici',
  value: '€97'
}, {
  name: 'Laboratori',
  value: '€47'
}, {
  name: 'Mappe Concettuali',
  value: '€37'
}, {
  name: 'Verifiche e Test',
  value: '€27'
}, {
  name: '6 Bonus Esclusivi',
  value: '€67'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-201">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[150px] pointer-events-none" data-id="element-202"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-secondary/15 rounded-full blur-[100px] pointer-events-none" data-id="element-203"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-204">
        <h2 className="text-3xl sm:text-6xl font-montserrat font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-205">
          💰 Offerta Speciale di Lancio
        </h2>

        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/30 shadow-[0_20px_60px_-20px_rgba(30,142,90,0.25)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-206">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-[#34A853] text-white font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_8px_20px_rgba(92,203,127,0.4)]" data-id="element-207">
            ⭐ L'OPZIONE PIÙ SCELTA
          </div>

          <p className="text-sm sm:text-3xl font-montserrat font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-208">
            CONTENUTI DEL KIT:
          </p>

          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-209">
            {items.map((item, i) => <div key={i} className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-210">
                <span data-id="element-211">{item.name}</span>
                <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-212">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-213">
              <span data-id="element-214">VALORE TOTALE:</span>
              <span className="text-badge-red line-through" data-id="element-215">€ 275</span>
            </div>
          </div>

          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/5 to-transparent border border-primary/20 py-3 sm:py-8 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-216">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-217"></div>
            <p className="text-primary font-bold mb-1 sm:mb-4 text-xs sm:text-lg" data-id="element-218">
              Prezzo Oggi:
            </p>
            <div className="text-text-main font-montserrat font-black text-5xl sm:text-8xl tracking-tighter leading-none flex items-center justify-center gap-2 sm:gap-4" data-id="element-219">
              <span data-id="element-220">🏆</span>
              <span data-id="element-221">€ 19.90</span>
            </div>
            <div className="text-text-sec sm:text-base font-medium mt-0.5 text-[16px]" data-id="element-222">
              (Pagamento unico — Accesso per sempre)
            </div>
          </div>

          <a href="https://www.edulabs.online/cart/43444696711286:1?locale=it" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Biologia Pronta — Il Kit Completo',
              content_type: 'product',
              value: 19.9,
              currency: 'EUR'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-montserrat font-black text-base sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_15px_40px_-10px_rgba(30,142,90,0.5)] mb-2 sm:mb-6" data-id="element-223">
            🚀 SÌ! VOGLIO BIOLOGIA PRONTA™
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-224">
            <span data-id="element-225">💳 Pagamento unico</span>
            <span data-id="element-226">•</span>
            <span data-id="element-227">⚡ Accesso immediato</span>
            <span data-id="element-228">•</span>
            <span data-id="element-229">🛡️ Garanzia 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}